///////////////////////////////////////////////
//                                           //
//  Program: IlsExportService.js             //
//  Application: Services                    //
//  Option: Used for ILS Export / MITS Feed  //
//  Developer: Orion Haus Dev                //
//  Date: 2026-07-10                         //
//                                           //
///////////////////////////////////////////////

import ApiService from "./ApiService";

class IlsExportService {
  /**
   * Fetch the ILS settings and last-generated status for a property.
   * Used to populate the ILS Export settings page on load.
   *
   * @param {string} propertySlug - 12-char property slug
   */
  getSettings(propertySlug) {
    let endPoint = "ils-settings/" + propertySlug;
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };

    let response = ApiService.getCall(inputData);
    return response;
  }

  /**
   * Trigger MITS 5.0 feed regeneration for a property.
   * Generates XML, validates against XSD, writes to server disk.
   *
   * @param {string} propertySlug - 12-char property slug
   */
  regenerateFeed(propertySlug) {
    let endPoint = "ils-feed-regenerate/" + propertySlug;
    let addditionalHeaderData = {};
    let postData = {};

    let inputData = {
      endPoint: endPoint,
      addditionalHeaderData: addditionalHeaderData,
      postData: postData,
    };

    let response = ApiService.postCall(inputData);
    return response;
  }
}

export default new IlsExportService();
